import type { SaleClass, SaleItem } from './types';

export const DC_DATA: SaleItem[] = [
  {
    name: 'ATLAS 2000',
    cls: 'Node',
    memory: '16 TB',
    nodes: '819',
    energy: '50 kW',
    reactor: 'Micro-Fission Cell',
    access: 'Standard',
    price: 0.05,
    tokens: '5,000 Tokens',
    emission: '0.57/hour',
    fdv: '$20m',
    status: '',
    zoom: 1.1,
    amb: 1.8,
  },
  {
    name: 'ATLAS 4000',
    cls: 'Node',
    memory: '20 TB',
    nodes: '1,638',
    energy: '100 kW',
    reactor: 'Compact Fission Core',
    access: 'Standard',
    price: 0.1,
    tokens: '10,000 Tokens',
    emission: '1.14/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.69,
  },
  {
    name: 'ATLAS 4090',
    cls: 'Node',
    memory: '24 TB',
    nodes: '4,096',
    energy: '250 kW',
    reactor: 'Dual Fission Array',
    access: 'Standard',
    price: 0.25,
    tokens: '25,000 Tokens',
    emission: '2.85/hour',
    fdv: '$20m',
    status: '',
    amb: 5.0,
    dir: 1.5,
    envInt: 3.0,
    fill: 0.2,
    hemi: 4.0,
  },
  {
    name: 'HELIOS PRO 5090',
    cls: 'Validator',
    memory: '32 TB',
    nodes: '8,192',
    energy: '2 MW',
    reactor: 'Plasma Ignition Drive',
    access: 'Advanced',
    price: 0.5,
    tokens: '50,000 Tokens',
    emission: '5.71/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.9,
    amb: 22.0,
    dir: 0.3,
    envInt: 2.0,
    hemi: 15.0,
    fill: 3.0,
  },
  {
    name: 'HELIOS ENERGY 6000',
    cls: 'Validator',
    memory: '96 TB',
    nodes: '9,830',
    energy: '5 MW',
    reactor: 'Sustained Plasma Reactor',
    access: 'Advanced',
    price: 0.6,
    tokens: '60,000 Tokens',
    emission: '6.85/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.97,
    amb: 26.0,
    dir: 3.8,
    envInt: 6.0,
    hemi: 19.0,
    fill: 0,
    center: 6.0,
    emissive: 0.3,
    coreAnim: true,
    shellTint: 0xd0d5dd,
  },
  {
    name: 'KRONOS 40',
    cls: 'Sequencer',
    memory: '480 TB',
    nodes: '16,384',
    energy: '25 MW',
    reactor: 'Micro-Fission Cell',
    access: 'Premium',
    price: 1,
    tokens: '100,000 Tokens',
    emission: '11.42/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.9,
    amb: 12.0,
    dir: 4.0,
    envInt: 8.0,
    hemi: 8.0,
    fill: 0.5,
    center: 8.0,
  },
  {
    name: 'KRONOS 60',
    cls: 'Sequencer',
    memory: '800 TB',
    nodes: '49,152',
    energy: '80 MW',
    reactor: 'Compact Fission Core',
    access: 'Premium',
    price: 3,
    tokens: '300,000 Tokens',
    emission: '34.25/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.8,
    camY: 0.15,
    amb: 6.0,
    dir: 3.0,
    envInt: 3.0,
    hemi: 4.0,
    fill: 0.3,
    emissive: 2.5,
    glowInt: 2.2,
    glowDensity: 0.5,
  },
  {
    name: 'KRONOS 90M',
    cls: 'Sequencer',
    memory: '940 TB',
    nodes: '81,920',
    energy: '150 MW',
    reactor: 'Dual Fission Array',
    access: 'Premium',
    price: 5,
    tokens: '500,000 Tokens',
    emission: '57.08/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.9,
    camY: 0.15,
    amb: 6.0,
    dir: 3.0,
    envInt: 3.0,
    hemi: 4.0,
    fill: 0.3,
    emissive: 2.5,
  },
  {
    name: 'TITAN A100',
    cls: 'Cluster',
    memory: '8 PB',
    nodes: '163,840',
    energy: '500 MW',
    reactor: 'Stellarator WM-I',
    access: 'Enterprise',
    price: 10,
    tokens: '1,000,000 Tokens',
    emission: '114.16/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.75,
    initRotY: 1.5708,
    amb: 5.0,
    dir: 1.3,
    envInt: 8.0,
    hemi: 3.3,
    fill: 0.7,
    center: 1.7,
    emissive: 0.5,
    float: true,
    glowColors: [0x00cc44, 0x2288ff, 0xff8800],
  },
  {
    name: 'TITAN ULTRA',
    cls: 'Cluster',
    memory: '19.2 PB',
    nodes: '409,600',
    energy: '800 MW',
    reactor: 'Stellarator WM-IV',
    access: 'Enterprise',
    price: 25,
    tokens: '2,500,000 Tokens',
    emission: '285.39/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.9,
    camY: 0.4,
    amb: 2.5,
    dir: 0.8,
    envInt: 4.0,
    hemi: 1.8,
    fill: 0.4,
    center: 1.0,
    emissive: 0.3,
    float: true,
    glowInt: 22.5,
    glowColors: [0xff44aa, 0xff66cc, 0xff2288, 0xff55bb, 0xff44aa],
  },
  {
    name: 'TITAN 1TW',
    glb: 'TITAN_1MW.glb',
    cls: 'Cluster',
    memory: '25.6 PB',
    nodes: '819,200',
    energy: '1 TW',
    reactor: 'Inertial Fusion Core',
    access: 'Enterprise',
    price: 50,
    tokens: '5,000,000 Tokens',
    emission: '570.78/hour',
    fdv: '$20m',
    status: '',
    zoom: 0.75,
    amb: 2.0,
    dir: 0.5,
    envInt: 3.0,
    hemi: 1.5,
    fill: 0.3,
    center: 0.8,
    emissive: 0.2,
    float: true,
    glowColors: [0x00cc44, 0x2288ff, 0xff8800],
  },
  {
    name: 'DEEP SPACE 100X',
    cls: 'Mainnet',
    memory: '192 PB',
    nodes: '1.6M',
    energy: '4 TW',
    reactor: 'Antimatter Annihilator',
    access: 'Enterprise Elite',
    price: 100,
    tokens: '10,000,000 Tokens',
    emission: '1,141.55/hour',
    fdv: '$20m',
    status: '',
    amb: 5.0,
    dir: 1.3,
    envInt: 8.0,
    hemi: 3.3,
    fill: 0.7,
    center: 1.7,
    emissive: 0.5,
    float: true,
    zoom: 0.85,
    camY: 0.45,
    glowColors: [0x00cc44, 0x2288ff, 0xff8800],
    ringAnim: true,
  },
  {
    name: 'DEEP SPACE H200 SXM',
    cls: 'Mainnet',
    memory: '141 PB',
    nodes: '3.1M',
    energy: '8 TW',
    reactor: 'Dual Antimatter Reactor',
    access: 'Enterprise Elite',
    price: 200,
    tokens: '20,000,000 Tokens',
    emission: '2,283.11/hour',
    fdv: '$20m',
    status: '',
    amb: 5.0,
    dir: 1.3,
    envInt: 8.0,
    hemi: 3.3,
    fill: 0.7,
    center: 1.7,
    emissive: 0.5,
    float: true,
    zoom: 0.85,
    camY: -0.15,
    initRotY: 0.5236,
    ringAnim: true,
    ringAmp: 1.2,
    ringTop: ['Cylinder001', 'Halo_Hull_Details_1'],
    ringBottom: ['Cylinder', 'Halo_Hull_Details_2'],
  },
  {
    name: 'DEEP SPACE B200',
    cls: 'Mainnet',
    memory: '180 PB',
    nodes: '4.1M',
    energy: '12 TW',
    reactor: 'Vacuum Cascade Core',
    access: 'Enterprise Elite',
    price: 250,
    tokens: '25,000,000 Tokens',
    emission: '2,853.88/hour',
    fdv: '$20m',
    status: '',
    amb: 5.0,
    dir: 1.3,
    envInt: 8.0,
    hemi: 3.3,
    fill: 0.7,
    center: 1.7,
    emissive: 0.5,
    float: true,
    initRotY: 1.5708,
    glowColors: [0xffcc00, 0x22cc44, 0xaa44ff],
    haloSpin: true,
  },
  {
    name: 'PROMETHEUS I',
    cls: 'Genesis',
    memory: '10 EB',
    nodes: '16.4M',
    energy: '80 TW',
    reactor: 'Stellar Siphon Array',
    access: 'Singularity',
    price: 1000,
    tokens: '100,000,000 Tokens',
    emission: '11,415.53/hour',
    fdv: '$20m',
    status: 'out-of-stock',
    amb: 5.0,
    dir: 1.3,
    envInt: 8.0,
    hemi: 3.3,
    fill: 0.7,
    center: 1.7,
    emissive: 0.5,
    float: true,
    zoom: 0.88,
    initRotY: 1.5708,
    glowColors: [0xffcc00, 0xffaa00, 0xffe044],
    innerOrbit: ['Halo', 'Halo_Lights'],
  },
  {
    name: 'GENESIS X \u00C6 W-3000',
    cls: 'Genesis',
    memory: '30 EB',
    nodes: '49.2M',
    energy: '255 TW',
    reactor: 'Hypernova Core',
    access: 'Singularity',
    price: 3000,
    tokens: '300,000,000 Tokens',
    emission: '34,246.58/hour',
    fdv: '$20m',
    status: 'preorder',
    amb: 5.0,
    dir: 1.3,
    envInt: 8.0,
    hemi: 3.3,
    fill: 0.7,
    center: 1.7,
    emissive: 0.5,
    float: true,
    zoom: 0.85,
    glowColors: [0x2288ff, 0x22cc44, 0xaa44ff],
    glowInt: 3.0,
    forceField: true,
  },
];

// Group by class
export const DC_CLASSES: SaleClass[] = (() => {
  const classes: SaleClass[] = [];
  let last = '';
  DC_DATA.forEach((dc, i) => {
    if (dc.cls !== last) {
      classes.push({ cls: dc.cls, indices: [] });
      last = dc.cls;
    }
    classes[classes.length - 1].indices.push(i);
  });
  return classes;
})();
